import type { ManualBill } from '@shared/services/payments/types/getManualBill.types';
import type { OutstandingBill } from '@shared/services/payments/types/getOutstandingBills.types';

const PaymentMethod = {
  AE: 'AE',
  CC: 'CC',
  DD: 'DD',
} as const;

type PaymentMethodType = (typeof PaymentMethod)[keyof typeof PaymentMethod];

const PaymentMode = {
  MobilePublic: '3',
  MobileSingpass: '2',
  Public: '0',
  Singpass: '1',
} as const;

const CardType = {
  AmericanExpress: 'AMEX',
  DinersClub: 'Diners Club',
  DirectDebit: 'Direct Debit',
  MasterCard: 'MasterCard',
  Visa: 'Visa',
} as const;

const PaymentStatus = {
  Failed: 'F',
  Pending: 'P',
  Success: 'S',
} as const;

interface EditableManualBill extends ManualBill {
  addedDate?: number;
  ClusterCode: string;
  InstitutionCode: string;
  InstitutionName: string;
  InvoiceNumber: string;
  InvoiceStatus?: string;
  isChecked?: boolean;
  isFullyPaidBill?: boolean;
  MemberNric?: string;
  PatientId?: null | string;
  updatedAmount?: number;
  VisitDate?: null | string;
}

interface EditableOutstandingBill extends OutstandingBill {
  isChecked?: boolean;
  isFullyPaidBill?: boolean;
  updatedAmount?: number;
}

interface ENETSError {
  codes: string[];
  msg: string;
}

type ENETSErrorList = ENETSError[];

interface IPaymentStatusDetail {
  background: string;
  okBtnText: string;
  statusMsg: string;
}

interface OutstandingBills {
  outstanding: EditableOutstandingBill[];
  pending: EditableOutstandingBill[];
}

interface PaymentReceipt {
  referenceNumber: string;
}

interface PaymentState {
  isValidEditAmount: boolean;
  manualBills: EditableManualBill[];
  outstandingBills: OutstandingBills;
  paymentReceipt: PaymentReceipt;
  selectedCluster: SelectedCluster;
}

type PaymentStatusType = Record<string, IPaymentStatusDetail>;

interface PaymentTypeProps {
  isSingpass?: boolean;
}

interface PayorInformationFormValues {
  contactNumber: string;
  emailAddress: string;
  fullName: string;
}

interface SelectedCluster {
  clusterCode: string;
  clusterName: string;
}

export type {
  EditableManualBill,
  EditableOutstandingBill,
  ENETSErrorList,
  PaymentMethodType,
  PaymentState,
  PaymentStatusType,
  PaymentTypeProps,
  PayorInformationFormValues,
  SelectedCluster,
};

export { CardType, PaymentMethod, PaymentMode, PaymentStatus };
